import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { SliderData, SliderSettingsData } from "../../../Data/Bonus/About";
import { IconGoogleData } from "../../../Data/Landing/Landing";
import { dynamicImage, Image } from "../../../Utils";

const Slider = () => {
  return (
    <section className="section-py-space">
      <div className="custom-container testimonial-main">
        <Row>
          <Col xs="12">
            <div className="pt-0">
              <Swiper {...SliderSettingsData} className="mySwiper">
                {SliderData.map((item, index) => (
                  <SwiperSlide className="testimonial-box mt-0" key={index}>
                    <div className="test-img">
                      <div>
                        <Image className="img-fluid" src={dynamicImage(`about/${item.image}.png`)} alt="test-img" />
                      </div>
                      {item.icon && <i className="test-wish fa fa-heart"></i>}
                    </div>
                    <div className="test-contain">
                      <h4>project manager</h4>
                      <h3>Advanced Equipment</h3>
                      <h6>I would suggest you discuss this further with the advertising team.</h6>
                      <ul className="test-icon">
                        {IconGoogleData.map((item, index) => (
                          <li key={index}>
                            <Link to={item} target="_blank">
                              <Image className="img-fluid" src={dynamicImage(`landing/testimonial/icon${index + 1}.png`)} alt="icon-google" />
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Slider;
